import { RectangleProps, Rectangle } from 'recharts';
import { RectRadius } from 'recharts/types/shape/Rectangle';
import { getPositiveGreenColor, getNegativeRedColor } from 'src/utils/graph';
import { signDependentValue } from 'src/utils/signDependentValue';
import { getColorVar } from 'src/utils/theme/colorVars';

interface Props extends RectangleProps {
	value: number;
}

const ROUNDED_BAR_RADIUS: RectRadius = [6, 6, 0, 0];

export default function ChartBar({ x, y, width, height, value }: Props) {
	const fill = signDependentValue(value, {
		positive: getPositiveGreenColor(),
		negative: getNegativeRedColor(),
		zero: getColorVar('text-default'),
	});

	return (
		<Rectangle
			x={x}
			y={y}
			width={width}
			height={height}
			fill={fill}
			radius={ROUNDED_BAR_RADIUS}
		/>
	);
}
